import React, { useState } from 'react';
import TitleBlock from '../elements/TitleBlock';
import SwapBlock from '../elements/SwapBlock';


function SwapCard() {
    const [showModal, setShowModal] = useState(false);

    return (
        <div>
            <TitleBlock type = {'info'}  />
            <SwapBlock />

        </div>
    );
}

export default SwapCard;
 